import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=2a5a23e6&scoped=true&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5a23e6",
  null
  
)

export default component.exports